import React from 'react';

const KayakIcon = (props) => {
  return (
    <img
      alt="Spływ kajakowy"
      src="/static/images/icons/place_types/kayak.svg"
      {...props}
    />
  );
};

export default KayakIcon;
